module.exports = ".bk-white{\r\n    background-color: white;\r\n}"